import React, { useEffect, useState, }  from 'react';
import { useNavigate } from 'react-router-dom';
import { WindowSize } from '../WindowSize.js';
import { useSelector,useDispatch } from 'react-redux';
import fetch from 'node-fetch';
import { GetUrl, GetMaintenanceUrl, CTicksToDateString } from '../Utility.js';


function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const navigate = useNavigate();

    const state=useSelector((state)=>state);
    const dispatch = useDispatch();
    
    const handleLogin = async (e) => {
        e.preventDefault();
        try
        {
          if(state.Request === 1)
          {
            return;
          }

          dispatch({type:'Request'});
            const response = await fetch(GetUrl() + 'Admin/Login', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json'
             },
            body: JSON.stringify({ email : email, pass : password }),
          });

          if (response.ok) {
              const data = await response.json();
              
              if(data.result === 0)
              {
                sessionStorage.setItem("secret_key", data.secret_key);
                dispatch({type:'UpdateRecommandPoint', Value : data.recommand_point});
                dispatch({type:'UpdateRegisterPoint', Value : data.register_point});
                navigate('/member'); // 로그인 성공 시 메인 페이지로 이동
              }
              else if(data.result === 1)
              {
                alert('로그인 실패(아이디를 확인 해 주세요)');  
              }
              else if(data.result === 2)
              {
                alert('로그인 실패(패스워드를 확인 해 주세요)');  
              }
          } else {
              alert('Network fail');
          }

          dispatch({type:'Response'});
        }
        catch(error)
        {
          dispatch({type:'Response'});
          console.error(error);
        }
    };

    return (
        <div id='login-box'>
          <div id="loginform">
              <form className="login-form" onSubmit={handleLogin}>
                  <h2>로그인</h2>
                  <input
                      type="text"
                      placeholder="E-mail"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                  />
                  <input
                      type="password"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                  />
                  <button type="submit">로그인</button>
              </form>
            </div>
        </div>
    );
}

export default Login;